import React, { useEffect, useState } from 'react';
import CommonCostEstimation from './CommonCostEstimate';
import Style from './CostEstimation.module.css';
import get from 'lodash/get';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import * as Yup from 'yup';
import initialImg from '../../../images/icons/upload_new.svg';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { Formik, Form } from 'formik';
import {
  costSheetUpload,
  UploadFileToS3,
  costSheetUploaded,
  saveCostEstimate,
  getCostEstimates
} from '../../constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import CommonToggleButton from '../../../components/Dashboard-res/CommonComponent/CommonToggleButton';

const costType = {
  basiCost: {
    label: 'Basic Cost',
    name: 'basiCost'
  },
  gST: {
    label: 'GST',
    name: 'gST'
  },
  AValue: {
    label: 'Agreement Value (Basic Cost + GST)',
    name: 'AValue',
    disabled: true
  },
  AValueNew: {
    label: 'Agreement Value (Basic Cost)',
    name: 'AValueNew',
    disabled: true
  },
  carPark: {
    label: 'Car Park',
    name: 'carPark'
  },
  infrastructureCharges: {
    label: 'Infrastructure Charges',
    name: 'infrastructureCharges'
  },
  others: {
    label: 'Others',
    name: 'others'
  },

  OthgST: {
    label: 'GST',
    name: 'OthgST'
  },
  totalCharges: {
    label: 'Total Other Charges',
    name: 'totalCharges',
    disabled: true
  },
  registrationCharges: {
    label: 'Registration Charges',
    name: 'registrationCharges'
  },
  stampDuty: {
    label: 'Stamp Duty',
    name: 'stampDuty'
  },
  documentCost: {
    label: 'Document Cost',
    name: 'documentCost',
    disabled: true
  },
  amount: {
    label: 'Amount',
    name: 'amount'
  },
  agreementValue: {
    label: 'Agreement Value',
    name: 'agreementValue'
  }
};

const FlatCostEst = ({ value, detailSubmit }) => {
  const { costEst_container_box } = Style;
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detSubmit, setDetSubmit] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [show, setShow] = useState(false);
  const [editCostSheet, setEditCostSheet] = useState(false);
  const [editConstruction, setEditConstruction] = useState(false);
  const [editBuildingPlan, setEditBuildingPlan] = useState(false);
  const [
    editConsiderationStatemetnLink,
    setEditConsiderationStatemetnLink
  ] = useState(false);

  const [costSheetDocId, setcostSheetDocId] = useState(null);
  const [constructionDocId, setConstructionCostDocId] = useState('');
  const [buildingDocId, setBuildingPlanDocId] = useState('');
  const [considerationStatmentDocId, setConsiderationStatmentDocId] = useState(
    ''
  );
  const [hasCostSheet, setHasCostSheet] = useState('');
  const [hasConstruction, setHasConstruction] = useState('');
  const [hasBuildingPlan, setHasBuildingPlan] = useState('');
  const [
    hasConsiderationStatemetnLink,
    setHasConsiderationStatemetnLink
  ] = useState('');
  const [getData, setData] = useState([]);
  const [getSepData, setSepData] = useState([]);
  const [selectedProduct, setSelection] = useState(value.selectedSubProperty());
  const [selectedProperty, setselectedProperty] = useState(
    value.selectedProperty()
  );
  const [constructionDuration, setConstructionDuration] = useState(false);
  const [loanType, setLoanType] = useState(value.selectedProperty());
  const [devStatusProp, setDevStatus] = useState(value.constructionStatus());
  const [shouldShowCostSheet, setShouldShowCostSheet] = useState(false);
  const [shouldShowConstr, setShouldShowConstr] = useState(false);
  const [shouldShowBuildingPlan, setShouldShowBuildingPlan] = useState(false);
  const [shouldShowDuration, setShouldShowDuration] = useState(false);
  const [twoCostType, setTwoCostType] = useState(false);
  const [firstCostType, setFirstCostType] = useState(true);

  useEffect(() => {
    if (loanType == 'New Purchase' && selectedProduct == 'Plot') {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setShouldShowCostSheet(true);
      setFirstCostType(true);
    } else if (loanType == 'Balance Transfer' && selectedProduct == 'Plot') {
      setData([costType['amount']]);
      setFirstCostType(false);
      setTwoCostType(false);
      setShouldShowCostSheet(false);
      setShouldShowConstr(true);
      setShouldShowBuildingPlan(true);
      setShouldShowDuration(true);
    } else if (selectedProperty == 'Plot+Construction') {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setFirstCostType(true);
      setSepData([costType['amount']]);
      setTwoCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(true);
      setShouldShowBuildingPlan(true);
      setShouldShowDuration(false);
    } else if (loanType == 'Self Construction') {
      setData([costType['amount']]);
      setFirstCostType(false);
      setTwoCostType(false);
      setShouldShowCostSheet(false);
      setShouldShowConstr(true);
      setShouldShowBuildingPlan(true);
      setShouldShowDuration(false);
    } else if (
      (loanType == 'Renovation/Improvement' && selectedProduct == 'Flat') ||
      (loanType == 'Renovation/Improvement' && selectedProduct == 'Villa')
    ) {
      setData([costType['amount']]);
      setFirstCostType(false);
      setTwoCostType(false);
      setShouldShowCostSheet(false);
      setShouldShowConstr(true);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (
      loanType == 'Renovation/Improvement' &&
      selectedProduct == 'Independent House'
    ) {
      setData([costType['amount']]);
      setFirstCostType(false);
      setTwoCostType(false);
      setShouldShowCostSheet(false);
      setShouldShowConstr(true);
      setShouldShowBuildingPlan(true);
      setShouldShowDuration(false);
    } else if (
      (devStatusProp == true &&
        loanType == 'Resale' &&
        selectedProduct == 'Flat') ||
      (devStatusProp == true &&
        loanType == 'Resale' &&
        selectedProduct == 'Villa')
    ) {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['carPark'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (
      (devStatusProp == true &&
        loanType == 'Resale' &&
        selectedProduct == 'Independent House') ||
      (devStatusProp == true &&
        loanType == 'Resale' &&
        selectedProduct == 'Plot')
    ) {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (
      (devStatusProp == false &&
        loanType == 'Resale' &&
        selectedProduct == 'Flat') ||
      (devStatusProp == false &&
        loanType == 'Resale' &&
        selectedProduct == 'Villa')
    ) {
      setData([
        costType['basiCost'],
        costType['AValueNew'],
        costType['carPark'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (
      (devStatusProp == false &&
        loanType == 'Resale' &&
        selectedProduct == 'Independent House') ||
      (devStatusProp == false &&
        loanType == 'Resale' &&
        selectedProduct == 'Plot')
    ) {
      setData([
        costType['basiCost'],

        costType['AValueNew'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (selectedProduct == 'Flat') {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['carPark'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (selectedProduct == 'Villa') {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['carPark'],
        costType['infrastructureCharges'],
        costType['others'],
        costType['OthgST'],
        costType['totalCharges'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setFirstCostType(true);
      setTwoCostType(false);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    } else if (selectedProduct == 'Independent House') {
      setData([
        costType['basiCost'],
        costType['gST'],
        costType['AValue'],
        costType['registrationCharges'],
        costType['stampDuty'],
        costType['documentCost']
      ]);
      setTwoCostType(false);
      setFirstCostType(true);
      setShouldShowCostSheet(true);
      setShouldShowConstr(false);
      setShouldShowBuildingPlan(false);
      setShouldShowDuration(false);
    }
  }, []);

  const validationSchema = Formikvalues => {
    const errors = {};

    getData.map(each => {
      if (
        !Formikvalues[each.name.toString()] ||
        Formikvalues[each.name.toString()] == ''
      ) {
        errors[each.name.toString()] = 'Required';
      }
    });
    if (
      shouldShowCostSheet == true &&
      Formikvalues.file[1] == undefined &&
      Formikvalues.isEditModeCos == false
    ) {
      errors['file[1]'] = 'Required';
    }
    if (
      shouldShowConstr == true &&
      Formikvalues.file[2] == undefined &&
      Formikvalues.isEditModeCnst == false
    ) {
      errors['file[2]'] = 'Required';
    }
    if (
      shouldShowBuildingPlan == true &&
      Formikvalues.file[3] == undefined &&
      Formikvalues.isEditModeBP == false
    ) {
      errors['file[3]'] = 'Required';
    }
    if (
      constructionDuration === true &&
      Formikvalues.file[4] == undefined &&
      Formikvalues.isEditDur == false
    ) {
      errors['file[4]'] = 'Required';
    }
    return errors;
  };

  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        isEditModeCos: false,
        isEditModeCnst: false,
        isEditModeBP: false,
        isEditDur: false,
        basiCost: '',
        gST: '',
        carPark: '',
        infrastructureCharges: '',
        others: '',
        registrationCharges: '',
        stampDuty: '',
        documentCost: '',
        totalCharges: '',
        AValue: '',
        AValueNew: '',
        amount: '',
        agreementValue: ''
      }}
      validate={Formikvalues => validationSchema(Formikvalues)}
    >
      {({
        values,
        handleBlur,
        isSubmitting,
        data,
        handleChange,
        errors,
        touched,
        setFieldError,
        setFieldValue,
        name,
        handleSubmit,
        setFieldTouched
      }) => {
        const applyCondtn = () => {
          if (docUploaded || docUploadError || loading || detSubmit)
            return true;
        };
        useEffect(() => {
          if (docUploadError || docUploaded || detSubmit) setLoading(false);
        }, [docUploaded, docUploadError, detSubmit]);

        const propsRenderer = () => {
          let props = {};
          if (docUploaded) {
            props.type = 'success';
            props.text = 'Document uploaded successfully';
            props.autoClose = true;
            return props;
          }

          if (docUploadError) {
            props.type = 'fail';
            props.text = 'Error uploading the file, please try again ';
            props.autoClose = true;
            return props;
          }

          if (loading) {
            props.type = 'loading';
            props.text = 'Uploading document. . . ';
            return props;
          }
          if (detSubmit) {
            props.type = 'loading';
            props.text = 'Submiting. . . ';
            return props;
          }
        };

        //upload cost sheet api
        const statusforUpload = (data, parameter) => {
          //setDocUploaded(false);

          costSheetUploaded(leadId, parameter, data.requestId)
            .then(res => {
              if (res.error) {
                throw new Error(res);
              }
              if (parameter == 'cost-sheet') {
                setcostSheetDocId(data.requestId);
              }
              if (parameter == 'construction-cost') {
                setConstructionCostDocId(data.requestId);
              }
              if (parameter == 'building-plan') {
                setBuildingPlanDocId(data.requestId);
              }
              if (parameter == 'construction-consideration') {
                setBuildingPlanDocId(data.requestId);
              }
              setDocUploaded(false);
            })
            .catch(async err => {
              setDocUploadError(true);
              setShow(true);
            });
        };
        const uploadFileToS3 = (data, file, parameter) => {
          if (data.url && data.requestId) {
            UploadFileToS3(data.url, file)
              .then(res => {
                if (res.error) {
                  throw new Error(res);
                }
                statusforUpload(data, parameter);
                setDocUploaded(true);
                setShow(true);
              })
              .catch(async err => {
                setDocUploadError(true);
                setShow(true);
              });
          }
        };

        const getS3Url = (index, parameter) => {
          if (values.file[index] && values.file[index][0]) {
            let file = values.file[index][0];
            costSheetUpload(leadId, parameter)
              .then(res => {
                setLoading(true);
                setShow(true);
                if (res.error) {
                  throw new Error(res);
                }

                uploadFileToS3(res, file, parameter);
              })
              .catch(async err => {
                setDocUploadError(true);
                setShow(true);
              });
          }
          setLoading(false);
        };

        useEffect(() => {
          getS3Url(1, 'cost-sheet');
        }, [values.file[1]]);

        useEffect(() => {
          getS3Url(2, 'construction-cost');
        }, [values.file[2]]);
        useEffect(() => {
          getS3Url(3, 'building-plan');
        }, [values.file[3]]);
        useEffect(() => {
          getS3Url(4, 'construction-consideration');
        }, [values.file[4]]);

        // calculations
        let basCost =
          parseInt(values?.basiCost || 0) + parseInt(values?.gST || 0);
        let TotalOtherCharges =
          parseInt(values?.carPark || 0) +
          parseInt(values?.infrastructureCharges || 0) +
          parseInt(values?.others || 0) +
          parseInt(values?.OthgST || 0);
        let DocumentCost =
          parseInt(values?.basiCost || 0) +
          parseInt(values?.gST || 0) +
          parseInt(values?.carPark || 0) +
          parseInt(values?.infrastructureCharges || 0) +
          parseInt(values?.others || 0) +
          parseInt(values?.OthgST || 0) +
          parseInt(values?.registrationCharges || 0) +
          parseInt(values?.stampDuty || 0);
        parseInt(values?.agreementValue || 0);
        values.totalCharges = TotalOtherCharges;
        values.AValue = basCost;
        values.AValueNew = basCost;
        values.documentCost = DocumentCost;

        //save api
        async function saveCostEstDetail() {
          setLoading(true);
          setDetSubmit(true);
          setShow(true);
          let body = {
            basicCosts: {
              basicCost: values?.basiCost || 0,
              basicGst: values?.gST || 0
            },
            otherCosts: {
              carPark: values?.carPark || 0,
              infraCharges: values?.infrastructureCharges || 0,
              others: values?.others || 0,
              gst: values?.OthgST || 0
            },
            regCosts: {
              registration: values?.registrationCharges || 0,
              stampDuty: values?.stampDuty || 0
            },
            constructionCostEstimate: values?.amount || 0,
            agreementValue: values?.agreementValue || 0,
            costSheetDocId: costSheetDocId,
            constructionCostDocId: constructionDocId,
            buildingPlanDocId: buildingDocId,
            constructionConsiderationStatmentDocId: considerationStatmentDocId,
            constructingWithin18Month: constructionDuration,
            totalCharges: TotalOtherCharges,
            AValue: basCost,
            AValueNew: basCost,
            documentCost: DocumentCost
          };

          try {
            const resSaveCostEst = await saveCostEstimate(leadId, body);
            if (!resSaveCostEst.isAxiosError) {
              setLoading(false);
              setShow(false);
              detailSubmit();
            } else {
              throw new Error(res);
            }
          } catch (err) {
            setSubmitError(
              err?.response?.data?.message ||
                'something went wrong! Please try again..'
            );
            setShow(true);
          }
        }

        //get api
        useEffect(() => {
          if (leadId)
            getCostEstimates(leadId)
              .then(res => {
                if (res) {
                  setFieldValue('basiCost', res?.basicCosts?.basicCost);
                  setFieldValue('gST', res?.basicCosts?.basicGst);
                  setFieldValue('carPark', res?.otherCosts?.carPark);
                  setFieldValue(
                    'infrastructureCharges',
                    res?.otherCosts?.infraCharges
                  );
                  setFieldValue('others', res?.otherCosts?.others);
                  setFieldValue('OthgST', res?.otherCosts?.gst);
                  setFieldValue(
                    'registrationCharges',
                    res?.regCosts?.registration
                  );
                  setFieldValue('stampDuty', res?.regCosts?.stampDuty);
                  setFieldValue('amount', res?.constructionCostEstimate);
                  setFieldValue('agreementValue', res?.agreementValue);

                  if (res?.constructingWithin18Month === true) {
                    setConstructionDuration(true);
                    setFieldValue('isEditDur', true);
                  } else {
                    setConstructionDuration(false);
                  }
                  if (res?.costSheetLink?.url) {
                    setHasCostSheet(res?.costSheetLink?.url);
                    setcostSheetDocId(res?.costSheetLink?.docId);
                    setFieldValue('isEditModeCos', true);
                  }
                  if (res?.constructionCostLink?.url) {
                    setHasConstruction(res?.constructionCostLink?.url);
                    setConstructionCostDocId(res?.constructionCostLink?.docId);
                    setFieldValue('isEditModeCnst', true);
                  }
                  if (res?.buildingPlanLink?.url) {
                    setHasBuildingPlan(res?.buildingPlanLink?.url);
                    setBuildingPlanDocId(res?.buildingPlanLink?.docId);
                    setFieldValue('isEditModeBP', true);
                  }
                  if (res?.constructionConsiderationStatemetnLink?.url) {
                    setHasConsiderationStatemetnLink(
                      res?.constructionConsiderationStatemetnLink?.url
                    );
                    setConsiderationStatmentDocId(
                      res?.constructionConsiderationStatemetnLink?.docId
                    );
                  }
                }
              })
              .catch(err => {
                console.log(err);
              });
        }, []);

        return (
          <Form>
            <React.Fragment>
              {applyCondtn() && (
                <PopUp {...propsRenderer()} setShow={setShow} show={show} />
              )}
              <div
                className={`${costEst_container_box} m-2 md:mx-auto p-8 py-10 md:p-8 font-roboto  shadow-lg rounded-lg`}
              >
                {firstCostType ? (
                  <p className="text-xl font-semibold mb-8">Cost Estimate</p>
                ) : (
                  <p className="text-xl font-semibold mb-8">
                    Construction Cost Estimate
                  </p>
                )}
                {getData.map(each => {
                  return (
                    <CommonCostEstimation
                      label={each.label}
                      name={each.name}
                      disabled={each.disabled}
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                      handleBlur={handleBlur}
                      setFieldError={setFieldError}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      handleSubmit={handleSubmit}
                    />
                  );
                })}
                {twoCostType && (
                  <p className="text-lg font-semibold mb-8">
                    Construction Cost Estimate
                  </p>
                )}
                {twoCostType &&
                  getSepData.map(each => {
                    return (
                      <CommonCostEstimation
                        label={each.label}
                        name={each.name}
                        disabled={each.disabled}
                        values={values}
                        handleChange={handleChange}
                        errors={errors}
                        touched={touched}
                        handleBlur={handleBlur}
                        setFieldError={setFieldError}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        handleSubmit={handleSubmit}
                      />
                    );
                  })}
              </div>
              <div className=" block ">
                {shouldShowCostSheet && (
                  <>
                    <p className="font-roboto font-bold text-black-400 lg:px-2 md:mr-auto sm:mx-auto xs:mx-auto py-3 text-md">
                      Cost Sheet
                    </p>

                    {hasCostSheet != '' && !editCostSheet ? (
                      <ShowGetImage
                        img={hasCostSheet}
                        setEdit={setEditCostSheet}
                      />
                    ) : (
                      <GlobalUploadComp
                        data={values}
                        imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        // showFullImage={showFullImage}
                        initialImg={initialImg} // initial image
                        subInst="Click here to Upload "
                        subtext="CHOOSE FILE"
                      />
                    )}
                  </>
                )}
                <React.Fragment>
                  <div className=" w-full flex flex-wrap lg:pr-4 lg:px-5 md:mx-auto mt-4 ">
                    {shouldShowConstr && (
                      <div className=" block lg:mr-auto md:mr-auto  mx-auto">
                        <p className="font-roboto font-bold text-black-400 lg:pr-4 lg:px-2 mr-auto py-3 text-md">
                          Construction Cost Estimation
                        </p>
                        {hasConstruction != '' && !editConstruction ? (
                          <ShowGetImage
                            img={hasConstruction}
                            setEdit={setEditConstruction}
                          />
                        ) : (
                          <GlobalUploadComp
                            data={values}
                            imgIndex={2} //0,1,2,3 depending upon the no of file sequence
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            setFieldError={setFieldError}
                            initialImg={initialImg} // initial image
                            //showFullImage={showFullImage}
                            subInst="Click here to Upload "
                            subtext="CHOOSE FRONT VIEW"
                          />
                        )}
                      </div>
                    )}
                    {shouldShowBuildingPlan && (
                      <div className=" block mx-auto">
                        <p className="font-roboto font-bold text-black-400 lg:pr-4 lg:px-2 mr-auto py-3 text-md">
                          Building Plan
                        </p>
                        {hasBuildingPlan != '' && !editBuildingPlan ? (
                          <ShowGetImage
                            img={hasBuildingPlan}
                            setEdit={setEditBuildingPlan}
                          />
                        ) : (
                          <GlobalUploadComp
                            data={values}
                            imgIndex={3} //0,1,2,3 depending upon the no of file sequence
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            setFieldError={setFieldError}
                            initialImg={initialImg} // initial image
                            //={showFullImage}
                            subInst="Click here to Upload "
                            subtext="CHOOSE FRONT VIEW"
                          />
                        )}
                      </div>
                    )}
                  </div>
                  {shouldShowDuration && (
                    <div className="mt-8 text-black-400">
                      <CommonToggleButton
                        name="construction"
                        labelName="Are you constructing house within 18 months?"
                        Id="construction"
                        labelFor="construction"
                        checked={constructionDuration}
                        stylesContainer={{
                          alignItems: 'left',
                          marginLeft: '0'
                        }}
                        onChange={e => {
                          setConstructionDuration(e.target.checked);
                        }}
                      />
                    </div>
                  )}

                  {constructionDuration === true && shouldShowDuration ? (
                    <div className=" block ">
                      <p className="font-roboto font-bold text-black-400 lg:pr-4 lg:px-2 mr-auto py-3 text-md ml-2">
                        Construction Consideration Statement
                      </p>
                      {hasConsiderationStatemetnLink != '' &&
                      !editConsiderationStatemetnLink ? (
                        <ShowGetImage
                          img={hasConsiderationStatemetnLink}
                          setEdit={setEditConsiderationStatemetnLink}
                        />
                      ) : (
                        <GlobalUploadComp
                          data={values}
                          imgIndex={4} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          initialImg={initialImg} // initial image
                          subInst="Click here to Upload "
                          subtext="Upload"
                        />
                      )}
                    </div>
                  ) : null}
                </React.Fragment>
              </div>

              <div>
                <button
                  type="button"
                  className="submitButton w-48"
                  onClick={e => {
                    saveCostEstDetail();
                  }}
                  disabled={Object.keys(errors).length}
                >
                  Next
                </button>
              </div>
            </React.Fragment>
          </Form>
        );
      }}
    </Formik>
  );
};
export default FlatCostEst;
